import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

export const RegiterPatient = createAsyncThunk(
  "login/RegiterPatient",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.PATIENT_REGISTER,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const savePatientDetails = createAsyncThunk(
  "login/savePatientDetails",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.SAVE_PATIENT_DETAIL,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

// ------------------ INITIAL STATE ------------------
const initialState = {
  loading: false,
  error: null,
  data: null,

  loadingSave: false,
  errorSave: null,
  dataSave: null,
};

// ------------------ SLICE ------------------
const RegisterSlice = createSlice({
  name: "register",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // REGISTER PATIENT
    builder
      .addCase(RegiterPatient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(RegiterPatient.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(RegiterPatient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // SAVE PATIENT DETAILS
      .addCase(savePatientDetails.pending, (state) => {
        state.loadingSave = true;
        state.errorSave = null;
      })
      .addCase(savePatientDetails.fulfilled, (state, action) => {
        state.loadingSave = false;
        state.dataSave = action.payload;
      })
      .addCase(savePatientDetails.rejected, (state, action) => {
        state.loadingSave = false;
        state.errorSave = action.payload;
      });
  },
});

export default RegisterSlice.reducer;
